import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaStar, FaHeart, FaFilter, FaRegHeart, FaArrowAltCircleRight } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { IoClose } from "react-icons/io5";
import axios from "axios";
// import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import SearchBar from "../components/SearchBar";

// const categories = [
//     "Electronics Devices",
//     "Computer & Laptop",
//     "Computer Accessories",
//     "SmartPhone",
//     "Headphone",
//     "Mobile Accessories",
//     "Gaming Console",
//     "Camera & Photo",
//     "TV & Home Appliances",
//     "Watches & Accessories",
//     "GPS & Navigation",
//     "Wearable Technology",
// ];

const priceRange = ["All Products", "Under 250", "250 - 500", "500 - 1000", "1000 - 5000", "5000 - 10000", "Above 10000"];
const priceOptionMap = {
    "All Products": [1, 100000],
    "Under 250": [1, 250],
    "250 - 500": [250, 500],
    "500 - 1000": [500, 1000],
    "1000 - 5000": [1000, 5000],
    "5000 - 10000": [5000, 10000],
    "Above 10000": [10000, 100000],
};

// const brands = ["Apple", "Samsung", "Redmi", "Oppo", "Vivo", "Boat", "Infinity", "JBL"];

function valuetext(value) {
    return `₹${value}`;
}

const ProductListing = () => {
    const { itemId } = useParams();
    const customerType = localStorage.getItem("CustomerType");
    const ledname = localStorage.getItem("LedName");
    const ledcode = localStorage.getItem("Ledcode");
    const ledemail = localStorage.getItem("LedEmail");

    const navigate = useNavigate();
    const location = useLocation();

    const [selectedCategory, setSelectedCategory] = useState({ name: "", id: "" });
    // const [selectedBrands, setSelectedBrands] = useState(["Apple", "Samsung"]);
    const [selectedPriceRange, setSelectedPriceRange] = useState("All Products");
    const [products, setProducts] = useState([]);

    const [showFilters, setShowFilters] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [productModels, setProductModels] = useState({});
    const { categoryId } = location.state || {};

    const [priceValue, setPriceValue] = useState([1, 100000]);
    const [inputMin, setInputMin] = useState("5000");
    const [inputMax, setInputMax] = useState("15000");
    const minDistance = 1000;

    const cutitemId = itemId?.split(" ")[0] || "";

    const [wishlist, setWishlist] = useState([]);
    const [loadingWishlist, setLoadingWishlist] = useState(true);

    const [quantities, setQuantities] = useState({});

    const [selectedVariant, setSelectedVariant] = useState("");

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getCategories/JAPAN_ACCESORIES`);
                if (!response.ok) {
                    throw new Error("Failed to fetch categories");
                }
                const data = await response.json();
                // Filter only single-word names (no spaces)
                const singleWordCategories = data.filter((category) => category.Name && !category.Name.includes(" "));
                setCategories(singleWordCategories.slice(0, 10)); // limit to first 10
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, [apiBaseUrl]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const res = await fetch(
                    `${apiBaseUrl}/getProductByFilter/JAPAN_ACCESORIES?filter=${encodeURIComponent(cutitemId)}`
                );
                const data = await res.json();
                setProducts(data.slice(0, 20));
            } catch (err) {
                console.error("Error fetching products:", err);
            }
        };
        fetchProducts();
    }, [apiBaseUrl, cutitemId]);

    // useEffect(() => {
    //     filterByPrice();
    // }, [priceValue, selectedCategory, selectedPriceRange]);

    useEffect(() => {
        if (categoryId) {
            applyFilters(categoryId);
        }
    });

    // When price changes
    // const handlePriceChange = (newPriceRange) => {
    //     setPriceValue(newPriceRange);
    //     applyFilters(categoryId, newPriceRange);
    // };

    const applyFilters = async (categoryId, customRange) => {
        let categoryData = [];

        try {
            // Primary fetch by category
            const categoryResponse = await fetch(
                `${apiBaseUrl}/getProductByCategory/JAPAN_ACCESORIES?Id=${encodeURIComponent(categoryId)}`
            );

            if (categoryResponse.ok) {
                categoryData = await categoryResponse.json();
            }

            // Fallback fetch by filter if categoryData is invalid or empty
            if (!Array.isArray(categoryData) || categoryData.length === 0) {
                const res = await fetch(
                    `${apiBaseUrl}/getProductByFilter/JAPAN_ACCESORIES?filter=${encodeURIComponent(cutitemId)}`
                );
                if (res.ok) {
                    categoryData = await res.json();
                }
            }

            if (!Array.isArray(categoryData)) {
                console.error("Invalid data format from category API");
                return;
            }

            // Apply price filter
            const [minPrice, maxPrice] = customRange || priceValue;
            let filtered = [];

            switch (customerType) {
                case "CUSTOMER":
                    filtered = categoryData.filter((p) => p.MOP >= minPrice && p.MOP <= maxPrice);
                    break;
                case "AGENT":
                    filtered = categoryData.filter((p) => p.AP >= minPrice && p.AP <= maxPrice);
                    break;
                case "DEALER":
                    filtered = categoryData.filter((p) => p.DP >= minPrice && p.DP <= maxPrice);
                    break;
                case "JS_MANAGER":
                case "TK_MANAGER":
                    filtered = categoryData.filter((p) => p.RealPrateTax >= minPrice && p.RealPrateTax <= maxPrice);
                    break;
                case "JS_EMPLOYEE":
                case "TK_EMPLOYEE":
                    filtered = categoryData.filter((p) => p.MRP >= minPrice && p.MRP <= maxPrice);
                    break;
                default:
                    filtered = categoryData.filter((p) => p.MRP >= minPrice && p.MRP <= maxPrice);
            }

            // Update state
            setProducts(filtered);
        } catch (error) {
            console.error("Error applying filters:", error);
        }
    };

    const handleSliderChange = (event, newValue, activeThumb) => {
        if (!Array.isArray(newValue)) return;

        let updated = [...priceValue];
        if (activeThumb === 0) {
            updated = [Math.min(newValue[0], priceValue[1] - minDistance), priceValue[1]];
        } else {
            updated = [priceValue[0], Math.max(newValue[1], priceValue[0] + minDistance)];
        }

        setPriceValue(updated);
        setSelectedPriceRange(""); // Deselect radio on manual slider move
    };

    // Sync input display when priceValue changes from outside (not while typing)
    useEffect(() => {
        setInputMin(String(priceValue[0]));
        setInputMax(String(priceValue[1]));
    }, [priceValue]);

    // const toggleBrand = (brand) => {
    //     setSelectedBrands((prev) => (prev.includes(brand) ? prev.filter((b) => b !== brand) : [...prev, brand]));
    // };

    const fullimage = (itemName, id, customer) => {
        navigate(`/fullimage/${itemName}/${id}/${customer}`);
        window.location.reload();
    };

    // const getPriceLabel = (product) => {
    //     switch (customerType) {
    //         case "AGENT":
    //             return `AP: ₹ ${product.AP}`;
    //         case "DEALER":
    //             return `DP: ₹ ${product.DP}`;
    //         case "JS_EMPLOYEE":
    //         case "TK_EMPLOYEE":
    //             return `Branch: ${product.Branch}   MRP: ₹ ${product.MRP}`;
    //         case "JS_MANAGER":
    //         case "TK_MANAGER":
    //             return `Rate: ₹ ${product.RealPrateTax}   MRP: ₹ ${product.MRP}`;
    //         default:
    //             return `MOP: ₹ ${product.MOP}   MRP: ₹ ${product.MRP}`;
    //     }
    // };

    // useEffect(() => {
    //     if (searchTerm.trim() !== "") {
    //         // Check if searchTerm is not empty
    //         const fetchProducts = async () => {
    //             try {
    //                 const response = await fetch(
    //                     `${apiBaseUrl}/getProductByFilter/JAPAN_ACCESORIES?filter=${encodeURIComponent(searchTerm)}`
    //                 );
    //                 const data = await response.json();
    //                 setProducts(data);
    //             } catch (error) {
    //                 console.error("Error fetching products:", error);
    //             }
    //         };

    //         fetchProducts();
    //     } else {
    //         setProducts([]); // Clear products if searchTerm is empty
    //     }
    // }, [apiBaseUrl, categoryId, searchTerm]);

    // useEffect(() => {
    //     if (searchTerm.trim() !== "") {
    //         // Check if searchTerm is not empty
    //         const fetchProducts = async () => {
    //             try {
    //                 const response = await fetch(
    //                     `${apiBaseUrl}/getProductByFilter/JAPAN_ACCESORIES?filter=${encodeURIComponent(searchTerm)}`
    //                 );
    //                 if (!response.ok) {
    //                     throw new Error(`HTTP error! status: ${response.status}`);
    //                 }
    //                 const data = await response.json();
    //                 setProducts(data);

    //                 // Fetch models for each product
    //                 data.forEach(async (product) => {
    //                     try {
    //                         const modelResponse = await fetch(
    //                             `${apiBaseUrl}/getProductByNewFilter/JAPAN_ACCESORIES?filter=${encodeURIComponent(
    //                                 product.ItemName
    //                             )}`
    //                         );
    //                         if (!modelResponse.ok) {
    //                             throw new Error(`HTTP error! status: ${modelResponse.status}`);
    //                         }
    //                         const modelData = await modelResponse.json();
    //                         const modelOptions = modelData.map((model) => ({ value: model.model, label: model.model }));

    //                         setProductModels((prevModels) => ({
    //                             ...prevModels,
    //                             [product.ID]: modelOptions,
    //                         }));
    //                     } catch (modelError) {
    //                         console.error("Error fetching models:", modelError);
    //                     }
    //                 });
    //             } catch (error) {
    //                 console.error("Error fetching products or models:", error);
    //             }
    //         };

    //         fetchProducts();
    //     } else {
    //         setProducts([]); // Clear products if searchTerm is empty
    //     }
    // }, [apiBaseUrl, categoryId, searchTerm]);

    useEffect(() => {
        const fetchFilteredProducts = async () => {
            if (searchTerm.trim() === "") {
                setProducts([]);
                return;
            }

            try {
                // Step 1: Fetch products by search term
                const response = await fetch(
                    `${apiBaseUrl}/getProductByFilter/JAPAN_ACCESORIES?filter=${encodeURIComponent(searchTerm)}`
                );
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setSelectedCategory("");

                // Step 2: Apply category filter (if selected)
                let filtered = [...data];
                if (selectedCategory.id) {
                    filtered = filtered.filter((product) => product.CategoryId === selectedCategory.id);
                }

                // Step 3: Apply price range filter
                const [minPrice, maxPrice] = priceValue;
                const customerType = localStorage.getItem("CustomerType");

                if (customerType === "CUSTOMER") {
                    filtered = filtered.filter((product) => product.MOP >= minPrice && product.MOP <= maxPrice);
                } else if (customerType === "AGENT") {
                    filtered = filtered.filter((product) => product.AP >= minPrice && product.AP <= maxPrice);
                } else if (customerType === "DEALER") {
                    filtered = filtered.filter((product) => product.DP >= minPrice && product.DP <= maxPrice);
                } else if (customerType === "JS_MANAGER" || customerType === "TK_MANAGER") {
                    filtered = filtered.filter(
                        (product) => product.RealPrateTax >= minPrice && product.RealPrateTax <= maxPrice
                    );
                } else if (customerType === "JS_EMPLOYEE" || customerType === "TK_EMPLOYEE") {
                    filtered = filtered.filter((product) => product.MRP >= minPrice && product.MRP <= maxPrice);
                } else {
                    filtered = filtered.filter((product) => product.MRP >= minPrice && product.MRP <= maxPrice);
                }

                setProducts(filtered);

                // Step 4: Fetch product models for dropdown (optional)
                filtered.forEach(async (product) => {
                    try {
                        const modelResponse = await fetch(
                            `${apiBaseUrl}/getProductByNewFilter/JAPAN_ACCESORIES?filter=${encodeURIComponent(
                                product.ItemName
                            )}`
                        );
                        if (!modelResponse.ok) {
                            throw new Error(`HTTP error! status: ${modelResponse.status}`);
                        }
                        const modelData = await modelResponse.json();
                        const modelOptions = modelData.map((model) => ({ value: model.model, label: model.model }));

                        setProductModels((prevModels) => ({
                            ...prevModels,
                            [product.ID]: modelOptions,
                        }));
                    } catch (modelError) {
                        console.error("Error fetching models:", modelError);
                    }
                });
            } catch (error) {
                console.error("Error in search + filter logic:", error);
            }
        };

        fetchFilteredProducts();
    }, [searchTerm, selectedCategory, priceValue, apiBaseUrl]);

    const renderPriceInfo = (product) => {
        if (!customerType) {
            return <span id="h3">MRP: ₹ {product.MRP}</span>;
        }

        switch (customerType) {
            case "CUSTOMER":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">MOP: ₹ {product.MOP}</div>
                            <div id="h3">MRP: ₹ {product.MRP}</div>
                        </div>
                        {/* <div>
                            <span className="text-[#d1d5db] font-normal text-sm">₹ </span>
                            <span className="text-[#d1d5db] line-through font-normal text-sm">{product.MRP}</span>
                        </div> */}
                    </div>
                );
            case "AGENT":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">AP: ₹ {product.AP}</div>
                            <div id="h3">MOP: ₹ {product.MOP}</div>
                        </div>

                        <div id="h3">MRP: ₹ {product.MRP}</div>
                    </div>
                );
            case "DEALER":
                // return <span id="h3">DP: ₹ {product.DP}</span>;
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">DP: ₹ {product.DP}</div>
                            <div id="h3">MOP: ₹ {product.MOP}</div>
                        </div>

                        <div id="h3">MRP: ₹ {product.MRP}</div>
                    </div>
                );
            case "JS_EMPLOYEE":
            case "TK_EMPLOYEE":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">Branch: {product.Branch}</div>
                            <div id="h3">MRP: ₹ {product.MRP}</div>
                        </div>
                    </div>
                );
            case "JS_MANAGER":
            case "TK_MANAGER":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">Rate: ₹{product.RealPrateTax}</div>
                            <div id="h3">MRP: ₹ {product.MRP}</div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        {/* <span id="h3">MOP: ₹ {product.MOP}</span>
                        &nbsp;&nbsp;&nbsp;&nbsp; */}
                        <div id="h3">MRP: ₹ {product.MRP}</div>
                    </div>
                );
        }
    };

    useEffect(() => {
        const fetchWishlist = async () => {
            const ledcode = localStorage.getItem("Ledcode");
            try {
                const res = await axios.get(`${apiBaseUrl}/wishlist/items/JAPAN_ACCESORIES/${ledcode}`);
                if (res.data.success && Array.isArray(res.data.items)) {
                    setWishlist(res.data.items);
                }
            } catch (err) {
                console.error("Fetch wishlist error:", err);
            } finally {
                setLoadingWishlist(false); // Important!
            }
        };

        fetchWishlist();
    }, [apiBaseUrl]);

    const getPriceByCustomerType = (product) => {
        const customerType = localStorage.getItem("CustomerType");

        switch (customerType) {
            case "CUSTOMER":
                return product.MOP;
            case "AGENT":
                return product.AP;
            case "DEALER":
                return product.DP;
            case "JS_MANAGER":
            case "TK_MANAGER":
                return product.RealPrateTax;
            case "JS_EMPLOYEE":
            case "TK_EMPLOYEE":
                return product.MRP;
            default:
                return product.MRP;
        }
    };

    const addToWishlist = async (product) => {
        const ledcode = localStorage.getItem("Ledcode");
        const price = getPriceByCustomerType(product);
        const payload = {
            ID: product.ID,
            ItemName: product.ItemName,
            MRP: price,
            ledcode: ledcode,
            Qty: 1,
            uniqueCode: 0,
        };

        try {
            const res = await axios.post(`${apiBaseUrl}/wishlist/add/JAPAN_ACCESORIES`, payload);

            if (res.data.success) {
                const newItem = {
                    ID: product.ID,
                    ItemName: product.ItemName,
                    MRP: price,
                    ledcode,
                    Qty: 1,
                    uniqueCode: 0,
                };
                setWishlist((prev) => [...prev, newItem]);

                toast.success("Added to wishlist");
                console.log(wishlist);
            } else {
                toast.error("Failed to add to wishlist");
            }
        } catch (err) {
            console.error("Add to wishlist error:", err);
            toast.error("Error adding to wishlist");
        }
    };

    const removeFromWishlist = async (productId) => {
        try {
            const res = await axios.delete(`${apiBaseUrl}/wishlist/delete/JAPAN_ACCESORIES/${productId}`);

            if (res.data.success) {
                setWishlist((prev) => prev.filter((item) => item.ID !== productId)); // Remove from local state
                toast.info("Removed from wishlist");
            } else {
                toast.error("Failed to remove from wishlist");
            }
        } catch (err) {
            console.error("Remove wishlist error:", err);
            toast.error("Error removing from wishlist");
        }
    };

    const toggleWishlist = async (product) => {
        const isInWishlist = wishlist.some((item) => item.ID === product.ID);
        if (isInWishlist) {
            await removeFromWishlist(product.ID);
        } else {
            await addToWishlist(product);
        }
    };

    const handleQuantityChange = (productId, value) => {
        setQuantities((prev) => ({
            ...prev,
            [productId]: value,
        }));
    };

    const handleAddToCart = (productId) => {
        console.log(productId);
        const product = products.find((p) => p.ID === productId);
        console.log(product);

        if (!product) {
            console.error("❌ Product not found for ID:", productId);
            toast.error("Product not found. Please refresh the page.");
            return;
        }

        addToCart(product);
    };

    const addToCart = async (product) => {
        const quantity = quantities[product.ID];

        if (quantity === "" || !/^\d+$/.test(quantity) || Number(quantity) <= 0) {
            toast.error("Please enter a valid quantity");
            return;
        }

        const qtyNumber = Number(quantity);
        const existingData = JSON.parse(localStorage.getItem("productData")) || [];

        // const index = existingData.findIndex((item) => item.id === product.ID);
        const index = existingData.findIndex((item) => item.id === product.ID && item.selectedVariant === selectedVariant);

        let quantityDifference = qtyNumber;
        let uniqueCode = generateUniqueCode();
        // let uniqueCode = "0";

        if (index !== -1) {
            const updatedQuantity = existingData[index].quantity + qtyNumber;
            if (updatedQuantity > product.Qty) {
                toast.error(`Total quantity exceeds stock (${product.Qty})`);
                return;
            }

            // Keep old code
            uniqueCode = existingData[index].uniqueCode;

            existingData[index].quantity = updatedQuantity;
        } else {
            if (qtyNumber > product.Qty) {
                toast.error(`Available stock is ${product.Qty}`);
                return;
            }

            existingData.push({
                itemName: product.ItemName,
                id: product.ID,
                mop: product.MOP,
                dp: product.DP,
                ap: product.AP,
                mrp: product.MRP,
                branch: product.Branch,
                realpratetax: product.RealPrateTax,
                quantity: qtyNumber,
                uniqueCode,
                selectedVariant, // Track variant in local storage
            });
        }

        // Save to localStorage
        localStorage.setItem("productData", JSON.stringify(existingData));

        const price = getNumericPrice(product);

        // Send to API
        try {
            const payload = {
                itemId: product.ID,
                uniqueCode, // Use the correct one
                itemName: product.ItemName,
                itemPrice: price,
                quantity: quantityDifference,
                ledname,
                ledcode,
                ledemail: ledemail || "no email",
            };
            console.log("Payload to API:", payload);

            const res = await axios.post(`${apiBaseUrl}/cart/add/JAPAN_ACCESORIES`, payload);

            console.log("API Response:", res.data);

            if (res.data.success) {
                toast.success("Item added to cart");
            } else {
                toast.error("Failed to sync with server");
            }
        } catch (err) {
            // console.error("Add to cart error:", err);
            // toast.error("Server error: unable to sync cart");
            console.error("Add to cart error:", err?.response?.data || err.message || err);
            toast.error("Server error: unable to sync cart");
        }

        setQuantities((prev) => ({ ...prev, [product.ID]: "" }));
    };

    const generateUniqueCode = () => {
        return (
            Date.now().toString(36) + // Timestamp in base36
            Math.random().toString(36).substring(2, 8).toUpperCase() // Random 6 chars
        );
    };

    const getNumericPrice = (product) => {
        switch (customerType) {
            case "CUSTOMER":
                return product.MOP ?? product.MRP;
            case "AGENT":
                return product.AP ?? product.MRP;
            case "DEALER":
                return product.DP ?? product.MRP;
            case "JS_EMPLOYEE":
            case "TK_EMPLOYEE":
            case "JS_MANAGER":
            case "TK_MANAGER":
                return product.MRP;
            default:
                return product.MRP;
        }
    };

    return (
        <div className="min-h-screen flex flex-col bg-[#F7F7F7]">
            <div className="sticky top-0 z-50">
                {/* <Navbar /> */}
                <SearchBar onSearch={setSearchTerm} />
            </div>

            <div className="flex gap-6 p-4">
                {/* Sidebar */}
                <aside className="w-[250px]  rounded-md py-4 px-6 space-y-6 bg-[white] hidden lg:block">
                    <div className="">
                        {/* Categories */}
                        <div>
                            <h3 className="font-semibold mb-2">CATEGORY</h3>
                            {categories.map((category) => (
                                <div key={category.Id} className="flex items-center gap-2 mb-2">
                                    <input
                                        type="radio"
                                        name="category"
                                        value={category.Name}
                                        checked={selectedCategory.name === category.Name}
                                        // onChange={() => {
                                        //     const newCategory = { name: category.Name, id: category.Id };
                                        //     setSelectedCategory(newCategory);
                                        //     applyFilters(category.Id, priceValue);
                                        // }}
                                        onChange={() => {
                                            const newCategory = { name: category.Name, id: category.Id };
                                            setSelectedCategory(newCategory);

                                            const defaultRange = priceOptionMap["All Products"];
                                            setSelectedPriceRange("All Products");
                                            setPriceValue(defaultRange);

                                            applyFilters(category.Id, defaultRange);
                                        }}
                                    />
                                    <label className="text-sm ">{category.Name}</label>
                                </div>
                            ))}
                        </div>

                        <div>
                            {/* PRICE RANGE */}
                            <div>
                                <h3 className="font-semibold mb-2 mt-2">PRICE RANGE</h3>

                                {/* price slider */}
                                <Slider
                                    getAriaLabel={() => "Minimum distance"}
                                    value={priceValue}
                                    onChange={handleSliderChange}
                                    onChangeCommitted={() => {
                                        setSelectedPriceRange("");
                                        applyFilters(selectedCategory.id, priceValue);
                                    }}
                                    valueLabelDisplay="auto"
                                    getAriaValueText={valuetext}
                                    disableSwap
                                    min={0}
                                    max={10000}
                                    step={100}
                                />

                                <div className="w-full px-2">
                                    <div className="flex justify-between text-sm text-[#949598]">
                                        <span>₹{priceValue[0]}</span>
                                        <span>₹{priceValue[1]}</span>
                                    </div>
                                </div>
                            </div>

                            {/* price input */}
                            {/* <div className="flex justify-between text-xs mt-1 mb-2">
                                <input
                                    type="number"
                                    placeholder="Min price"
                                    className="border px-2 py-1 rounded w-1/2 mr-1"
                                    value={inputMin}
                                    onChange={(e) => setInputMin(e.target.value)}
                                    onBlur={() => {
                                        const newMin = parseInt(inputMin, 10);
                                        if (
                                            !isNaN(newMin) &&
                                            newMin >= 0 &&
                                            newMin <= priceValue[1] - minDistance &&
                                            newMin % 100 === 0
                                        ) {
                                            const updated = [newMin, priceValue[1]];
                                            setPriceValue(updated);
                                            setSelectedPriceRange("");
                                            applyFilters(selectedCategory.id, updated);
                                        }
                                        setInputMin(String(priceValue[0]));
                                    }}
                                />
                                <input
                                    type="number"
                                    placeholder="Max price"
                                    className="border px-2 py-1 rounded w-1/2 ml-1"
                                    value={inputMax}
                                    onChange={(e) => setInputMax(e.target.value)}
                                    onBlur={() => {
                                        const newMax = parseInt(inputMax, 10);
                                        if (
                                            !isNaN(newMax) &&
                                            newMax <= 10000 &&
                                            newMax >= priceValue[0] + minDistance &&
                                            newMax % 100 === 0
                                        ) {
                                            const updated = [priceValue[0], newMax];
                                            setPriceValue(updated);
                                            setSelectedPriceRange("");
                                            applyFilters(selectedCategory.id, updated);
                                        }
                                        setInputMax(String(priceValue[1]));
                                    }}
                                />
                            </div> */}

                            {/* price radio */}
                            <div className="mt-4">
                                {priceRange.map((price) => (
                                    <div key={price} className="flex items-center gap-2 mb-1">
                                        <input
                                            type="radio"
                                            name="priceRange"
                                            checked={selectedPriceRange === price}
                                            onChange={() => {
                                                const range = priceOptionMap[price];
                                                setSelectedPriceRange(price);
                                                setPriceValue(range);
                                                applyFilters(selectedCategory.id, range);
                                            }}
                                        />
                                        <label className="text-sm">{price}</label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Brands */}
                        {/* <div>
                        <h3 className="font-semibold mb-2">POPULAR BRANDS</h3>
                        <div className="grid grid-cols-2 gap-y-2">
                            {brands.map((brand) => (
                                <div key={brand} className="flex items-center gap-2">
                                    <input
                                        type="checkbox"
                                        checked={selectedBrands.includes(brand)}
                                        onChange={() => toggleBrand(brand)}
                                    />
                                    <label className="text-sm">{brand}</label>
                                </div>
                            ))}
                        </div>
                    </div> */}
                    </div>
                </aside>

                {/*Main Product Grid */}
                <main className="flex-1 relative">
                    {/* Filter toggle button */}
                    <div className="flex flex-row justify-between items-center mb-4  lg:hidden">
                        {/* Search + Sort */}
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                            {/* <input
                                type="text"
                                placeholder="Search for anything..."
                                className="w-full sm:w-1/2 px-3 py-2 rounded "
                            /> */}
                        </div>
                        <div className="flex">
                            <button
                                onClick={() => setShowFilters(!showFilters)}
                                className="flex items-center gap-2 rounded px-4 py-2 bg-white shadow text-sm font-medium "
                            >
                                {showFilters ? <IoClose /> : <FaFilter />}
                                <span className="text-md">Filter</span>
                            </button>
                        </div>
                    </div>

                    {/* Filter Sidebar for mobile */}
                    {showFilters && (
                        <aside className="block lg:hidden bg-[white] p-4 mb-6 rounded shadow">
                            {/* sort  */}
                            {/* <div className="flex justify-end mb-2 items-center">
                                <label htmlFor="sort" className="mr-2 text-sm font-medium">
                                    Sort by:
                                </label>
                                <select className="px-2 py-1 border rounded text-sm ">
                                    <option>Most Popular</option>
                                    <option>Lowest Price</option>
                                    <option>Highest Rated</option>
                                </select>
                            </div> */}

                            {/* category */}
                            <h3 className="font-semibold mb-2">CATEGORY</h3>
                            {categories.map((category) => (
                                <div key={category.Id} className="flex items-center gap-2 mb-2">
                                    <input
                                        type="radio"
                                        name="category"
                                        value={category.Name}
                                        checked={selectedCategory.name === category.Name}
                                        // onChange={() => {
                                        //     const newCategory = { name: category.Name, id: category.Id };
                                        //     setSelectedCategory(newCategory);
                                        //     applyFilters(category.Id, priceValue);
                                        // }}
                                        onChange={() => {
                                            const newCategory = { name: category.Name, id: category.Id };
                                            setSelectedCategory(newCategory);

                                            const defaultRange = priceOptionMap["All Products"];
                                            setSelectedPriceRange("All Products");
                                            setPriceValue(defaultRange);

                                            applyFilters(category.Id, defaultRange);
                                        }}
                                    />
                                    <label className="text-sm font-medium">{category.Name}</label>
                                </div>
                            ))}

                            {/* Price Range */}
                            <div className="mt-6">
                                <h3 className="font-semibold mb-2">PRICE RANGE</h3>

                                {/* Price slider */}
                                <Slider
                                    getAriaLabel={() => "Minimum distance"}
                                    value={priceValue}
                                    onChange={handleSliderChange}
                                    onChangeCommitted={() => {
                                        setSelectedPriceRange("");
                                        applyFilters(selectedCategory.id, priceValue);
                                    }}
                                    valueLabelDisplay="auto"
                                    getAriaValueText={valuetext}
                                    disableSwap
                                    min={0}
                                    max={10000}
                                    step={100}
                                />

                                <div className="w-full px-2">
                                    <div className="flex justify-between text-sm text-[#949598]">
                                        <span>₹{priceValue[0]}</span>
                                        <span>₹{priceValue[1]}</span>
                                    </div>
                                </div>

                                {/* price input  */}
                                {/* <div className="flex justify-between text-xs mt-2 mb-2">
                                    <input
                                        type="number"
                                        placeholder="Min price"
                                        className="border px-2 py-1 rounded w-1/2 mr-1"
                                        value={inputMin}
                                        onChange={(e) => setInputMin(e.target.value)}
                                        onBlur={() => {
                                            const newMin = parseInt(inputMin, 10);
                                            if (
                                                !isNaN(newMin) &&
                                                newMin >= 0 &&
                                                newMin <= priceValue[1] - minDistance &&
                                                newMin % 100 === 0
                                            ) {
                                                const updated = [newMin, priceValue[1]];
                                                setPriceValue(updated);
                                                setSelectedPriceRange("");
                                                applyFilters(selectedCategory.id, updated);
                                            }
                                            setInputMin(String(priceValue[0]));
                                        }}
                                    />
                                    <input
                                        type="number"
                                        placeholder="Max price"
                                        className="border px-2 py-1 rounded w-1/2 ml-1"
                                        value={inputMax}
                                        onChange={(e) => setInputMax(e.target.value)}
                                        onBlur={() => {
                                            const newMax = parseInt(inputMax, 10);
                                            if (
                                                !isNaN(newMax) &&
                                                newMax <= 10000 &&
                                                newMax >= priceValue[0] + minDistance &&
                                                newMax % 100 === 0
                                            ) {
                                                const updated = [priceValue[0], newMax];
                                                setPriceValue(updated);
                                                setSelectedPriceRange("");
                                                applyFilters(selectedCategory.id, updated);
                                            }
                                            setInputMax(String(priceValue[1]));
                                        }}
                                    />
                                </div> */}

                                {/* Price radio  */}
                                <div className="mt-4">
                                    {priceRange.map((price) => (
                                        <div key={price} className="flex items-center gap-2 mb-1">
                                            <input
                                                type="radio"
                                                name="priceRange"
                                                checked={selectedPriceRange === price}
                                                onChange={() => {
                                                    const range = priceOptionMap[price];
                                                    setSelectedPriceRange(price);
                                                    setPriceValue(range);
                                                    applyFilters(selectedCategory.id, range);
                                                }}
                                            />
                                            <label className="text-sm">{price}</label>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Brands */}
                            {/* <div className="mt-6">
                                <h3 className="font-semibold mb-2">POPULAR BRANDS</h3>
                                <div className="grid grid-cols-2 gap-y-2">
                                    {brands.map((brand) => (
                                        <div key={brand} className="flex items-center gap-2">
                                            <input
                                                type="checkbox"
                                                checked={selectedBrands.includes(brand)}
                                                onChange={() => toggleBrand(brand)}
                                            />
                                            <label className="text-sm">{brand}</label>
                                        </div>
                                    ))}
                                </div>
                            </div> */}
                        </aside>
                    )}

                    {/* Main Product Grid */}

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-4 w-full">
                        {products.map((product, index) => (
                            <div
                                key={product.ID}
                                className="product-card w-full flex flex-col gap-1  rounded-md mb-4  border-[#d1d5db] bg-[white]"
                            >
                                <div
                                    key={product.ID}
                                    className="relative group w-full lg:h-[313px] md:h-[270px] sm:h-[250px] h-[200px] flex flex-col justify-center items-center bg-[white] gap-[2%] cursor-pointer overflow-hidden"
                                >
                                    {/* Wishlist Button */}
                                    {!loadingWishlist && customerType === "CUSTOMER" && (
                                        <button
                                            className="absolute top-3 right-3 text-[#d1d5db] hover:text-[red]"
                                            onClick={() => toggleWishlist(product)}
                                        >
                                            {wishlist.some((item) => item.ID === product.ID) ? (
                                                <FaHeart size={20} className="text-[red]" />
                                            ) : (
                                                <FaRegHeart size={20} />
                                            )}
                                        </button>
                                    )}

                                    {/* Product Image */}
                                    <div
                                        onClick={() => fullimage(product.ItemName, product.ID, customerType)}
                                        className="w-[68%] h-[68%] flex justify-center items-center"
                                    >
                                        <img
                                            src={`${apiLocalUrl}/uploads/${product.ID}.jpg?v=${Date.now()}`}
                                            alt={product.ItemName}
                                            className="size-[90%] object-contain mix-blend-multiply"
                                        />
                                    </div>

                                    {/* Add to Cart Section */}

                                    <div className=" w-full text-center">
                                        <div className="mx-4 bg-gradient-to-r from-[#8b0000] to-[#d78e8e] rounded text-[white] p-2 flex items-center justify-center">
                                            <div className="flex">
                                                <span className="text-lg font-medium">🛒</span>
                                                <span className=" hidden md:flex lg:text-md sm:text-sm text-xs font-medium items-center">
                                                    Add to Cart
                                                </span>
                                            </div>

                                            <input
                                                type="text"
                                                min="1"
                                                value={quantities[product.ID] || ""}
                                                onChange={(e) => handleQuantityChange(product.ID, e.target.value)}
                                                // onBlur={() => handleBlur(product.ID)}
                                                className="md:w-12 w-10 px-1 py-0.5 text-[black] rounded  mx-1 lg:text-md sm:text-sm text-xs font-medium"
                                            />
                                            <span
                                                role="button"
                                                onClick={() => handleAddToCart(product.ID)}
                                                className="cursor-pointer hover:underline"
                                            >
                                                <FaArrowAltCircleRight className="md:size-6 size-5" />
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    onClick={() => fullimage(product.ItemName, product.ID, customerType)}
                                    className="w-full md:h-[18vh] h-auto flex flex-col items-start py-2 gap-1 px-4 rounded-b-[10px] bg-[white]"
                                >
                                    {/* <p className="text-sm text-[#a4a7ab] mb-1">Category</p> */}
                                    <span className="lg:text-md sm:text-sm text-xs font-medium text-left w-[70%]">
                                        {product.ItemName}
                                    </span>
                                    {/* Rating */}
                                    {/* <div className="flex gap-1 ">
                                        {[...Array(5)].map((_, i) => (
                                            <FaStar key={i} className="text-[#FACC15] text-sm" />
                                        ))}
                                    </div> */}

                                    <div className="flex flex-row justify-between items-center w-full gap-2">
                                        <span className="lg:text-md sm:text-sm text-xs text-[#2563EB] font-semibold text-left w-full">
                                            {renderPriceInfo(product)}
                                        </span>
                                        {/* <span className="text-[#d1d5db] text-sm">₹</span> */}
                                        {/* <span className="text-[#d1d5db] line-through text-sm">{product.MRP}</span> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </main>
            </div>
            <div className="lg:mt-[6%] mt-[10%]">
                <Footer />
            </div>
            <ToastContainer autoClose={1500} />
        </div>
    );
};

export default ProductListing;
